<template>
    <div class="content">
          <!-- 
        - #BLOG
      -->

      <section class="section blog" id="blog">
        <div class="container">
          <h2 class="h2 section-title underline">Our Blog & News</h2>

          <ul class="blog-list">
            <li>
              <div class="blog-card">
                <figure class="banner">
                  <a href="#">
                    <img
                      src="https://raw.githubusercontent.com/codewithsadee/desinic/master/assets/images/blog-1.jpg"
                      width="750"
                      height="350"
                      loading="lazy"
                      alt="Vestibulum massa arcu, consectetu pellentesque scelerisque."
                      class="img-cover"
                    />
                  </a>
                </figure>

                <div class="content">
                  <h3 class="h3 title">
                    <a href="#">
                      Vestibulum massa arcu, consectetu pellentesque
                      scelerisque.
                    </a>
                  </h3>

                  <p class="text">
                    Sed quis sagittis velit. Aliquam velit eros, bibendum ut
                    massa et, consequat laoreet erat nam ac imperdiet.
                  </p>

                  <div class="meta">
                    <div class="publish-date">
                      <ion-icon name="time-outline"></ion-icon>

                      <time datetime="2022-03-07">7 December, 2023</time>
                    </div>

                    <button class="comment" aria-label="Comment">
                      <ion-icon name="chatbubble-outline"></ion-icon>

                      <data value="15">15</data>
                    </button>

                    <button class="share" aria-label="Share">
                      <ion-icon name="share-social-outline"></ion-icon>
                    </button>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="blog-card">
                <figure class="banner">
                  <a href="#">
                    <img
                      src="https://raw.githubusercontent.com/codewithsadee/desinic/master/assets/images/blog-2.jpg"
                      width="750"
                      height="350"
                      loading="lazy"
                      alt="Quisque egestas iaculis felis eget placerat ut pulvinar mi."
                      class="img-cover"
                    />
                  </a>
                </figure>

                <div class="content">
                  <h3 class="h3 title">
                    <a href="#">
                      Quisque egestas iaculis felis eget placerat ut pulvinar
                      mi.
                    </a>
                  </h3>

                  <p class="text">
                    Sed quis sagittis velit. Aliquam velit eros, bibendum ut
                    massa et, consequat laoreet erat nam ac imperdiet.
                  </p>

                  <div class="meta">
                    <div class="publish-date">
                      <ion-icon name="time-outline"></ion-icon>

                      <time datetime="2022-03-07">3 August, 2023</time>
                    </div>

                    <button class="comment" aria-label="Comment">
                      <ion-icon name="chatbubble-outline"></ion-icon>

                      <data value="15">15</data>
                    </button>

                    <button class="share" aria-label="Share">
                      <ion-icon name="share-social-outline"></ion-icon>
                    </button>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="blog-card">
                <figure class="banner">
                  <a href="#">
                    <img
                      src="https://raw.githubusercontent.com/codewithsadee/desinic/master/assets/images/blog-3.jpg"
                      width="750"
                      height="350"
                      loading="lazy"
                      alt="Fusce sem ligula, imperdiet sed nisi sit amet, euismod posuere."
                      class="img-cover"
                    />
                  </a>
                </figure>

                <div class="content">
                  <h3 class="h3 title">
                    <a href="#">
                      Fusce sem ligula, imperdiet sed nisi sit amet, euismod
                      posuere.
                    </a>
                  </h3>

                  <p class="text">
                    Sed quis sagittis velit. Aliquam velit eros, bibendum ut
                    massa et, consequat laoreet erat nam ac imperdiet.
                  </p>

                  <div class="meta">
                    <div class="publish-date">
                      <ion-icon name="time-outline"></ion-icon>

                      <time datetime="2022-03-07">29 April, 2023</time>
                    </div>

                    <button class="comment" aria-label="Comment">
                      <ion-icon name="chatbubble-outline"></ion-icon>

                      <data value="15">15</data>
                    </button>

                    <button class="share" aria-label="Share">
                      <ion-icon name="share-social-outline"></ion-icon>
                    </button>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="blog-card">
                <figure class="banner">
                  <a href="#">
                    <img
                      src="https://raw.githubusercontent.com/codewithsadee/desinic/master/assets/images/blog-4.jpg"
                      width="750"
                      height="350"
                      loading="lazy"
                      alt="Donec feugiat mollis nisi in dignissim. Morbi sollicitudin quis."
                      class="img-cover"
                    />
                  </a>
                </figure>

                <div class="content">
                  <h3 class="h3 title">
                    <a href="#">
                      Donec feugiat mollis nisi in dignissim. Morbi sollicitudin
                      quis.
                    </a>
                  </h3>

                  <p class="text">
                    Sed quis sagittis velit. Aliquam velit eros, bibendum ut
                    massa et, consequat laoreet erat nam ac imperdiet.
                  </p>

                  <div class="meta">
                    <div class="publish-date">
                      <ion-icon name="time-outline"></ion-icon>

                      <time datetime="2022-03-07">16 March, 2023</time>
                    </div>

                    <button class="comment" aria-label="Comment">
                      <ion-icon name="chatbubble-outline"></ion-icon>

                      <data value="15">15</data>
                    </button>

                    <button class="share" aria-label="Share">
                      <ion-icon name="share-social-outline"></ion-icon>
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
 

    </div>
</template>

<style scoped>


/*-----------------------------------*\
  #BLOG
\*-----------------------------------*/

.blog {
  padding-block-end: 120px;
}

.blog-list {
  display: grid;
  gap: 30px;
}

.blog-card {
  padding: 20px;
  box-shadow: var(--shadow);
  border-radius: var(--radius-12);
}

.blog-card .banner {
  border-radius: var(--radius-12);
  overflow: hidden;
  margin-block-end: 15px;
}

.blog-card .banner img {
  transition: var(--transition-2);
}

.blog-card .banner a:is(:hover, :focus) img {
  transform: scale(1.1);
}

.blog-card .title {
  color: var(--st-patricks-blue);
  font-size: var(--fs-6);
  line-height: 1.2;
  margin-block-end: 15px;
}

.blog-card .title > a {
  color: inherit;
}

.blog-card .title > a:is(:hover, :focus) {
  color: var(--razzmatazz);
}

.blog-card .text {
  margin-block-end: 15px;
}

.blog-card .meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  font-size: var(--fs-8);
  color: var(--purple-navy);
  font-weight: var(--fw-500);
  padding-block-end: 10px;
}

.blog-card .meta ion-icon {
  color: var(--winter-sky);
  font-size: 22px;
  --ionicon-stroke-width: 35px;
}

.publish-date,
.comment {
  display: flex;
  align-items: center;
  gap: 8px;
}

.comment {
  color: inherit;
  margin-inline-start: auto;
}

</style>